import PropTypes from 'prop-types';
import uuid from 'react-uuid';
import cx from 'classnames';
import React, {
  useState,
  useEffect
} from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { firestore } from '../firebase';

const Search = (props) => {
  const {
    query,
    searchfnc,
    dataprop,
    value,
  } = props;
  const activeSearch = true;

  const [dataObjs, SetDataObjs] = useState([]);
  const [Loading, SetLoading] = useState(false);

  const selected = (typeof value !== 'undefined') ? dataObjs.filter((res) => res === value) : [];
  const searchId = `${dataprop}_${uuid()}`;

  // const displayString = (options, optiondisplay) => {
  //   const displayStr = [];
  //   optiondisplay.forEach((option) => {
  //     const displaycheck = option.indexOf('option_');
  //     if (displaycheck === -1) displayStr.push(option);
  //     else displayStr.push(options[option.split('option_')[1]]);
  //   });
  //   return displayStr.join('');
  // };

  useEffect(() => {
    SetLoading(true);
    const fetchData = () => {
      firestore.collection('Filters').doc(query.name).onSnapshot((querySnapshot) => {
        if (querySnapshot.exists) {
          const doc = querySnapshot.data();
          SetDataObjs(doc.data.sort());
        }
        SetLoading(false);
      });
    };
    fetchData();
  }, []);

  let typeaheadobj;

  if (Loading) return <div>Loading Search Options...</div>;
  // if (error) return <div>Error Loading Search Options</div>;
  // if (!data) return <div>No Data Found to Search</div>;

  return (
    <>
      <div className={cx('search-wrapper', {
        active: activeSearch,
      })}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* <div className="input-holder"> */}
          <FontAwesomeIcon icon={faSearch} />
        &nbsp;
          <div style={{ width: '100%' }}>
            <Typeahead
              // className="search-input"
              onChange={(e) => {
                searchfnc(e);
              }}
              options={dataObjs}
              // labelKey={(option) => displayString(option, optionDisplay)}
              type="text"
              name={dataprop}
              id={`${dataprop}_${uuid()}`}
              inputProps={{ id: searchId }}
              ref={(ref) => { typeaheadobj = ref; }}
              selected={selected}
            />
          </div>
          <button
            type="button"
            aria-label="Close Search"
            style={{ marginLeft: '0.2rem' }}
            onClick={() => {
              searchfnc();
              typeaheadobj.clear();
            }}
            className="close"
          />
        </div>
      </div>
    </>
  );
};

Search.propTypes = {
  query: PropTypes.shape({
    name: PropTypes.string,
    // url: PropTypes.string,
    options: PropTypes.objectOf(PropTypes.string),
    // options: PropTypes.objectOf(PropTypes.object, PropTypes.string, PropTypes.number),
    isMounted: PropTypes.objectOf(PropTypes.bool),
    initData: PropTypes.arrayOf(PropTypes.object),
    mergeField: PropTypes.string
  }),
  searchfnc: PropTypes.func,
  dataprop: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};
Search.defaultProps = {
  query: {
    url: '',
    options: {},
    isMounted: { current: false },
    initData: []
  },
  searchfnc: () => { },
  dataprop: '',
  value: undefined,
};

export default Search;
